import { FadeIn } from "./FadeIn";
import { FACILITIES } from "../data/content";

const BORDERS = [
  "border-2 border-red-500 shadow-lg shadow-red-950/40",
  "border-2 border-emerald-400 shadow-lg shadow-emerald-950/40",
  "border-2 border-amber-400 shadow-lg shadow-amber-950/40",
  "border-2 border-rose-400 shadow-lg shadow-rose-950/40",
  "border-2 border-amber-500 shadow-lg shadow-yellow-950/40",
  "border-2 border-cyan-400 shadow-lg shadow-cyan-950/40",
];

export const Facilities = () => (
  <section
    id="facilities"
    data-testid="facilities-section"
    className="px-4 sm:px-8 lg:px-12 py-16 md:py-24 max-w-7xl mx-auto"
  >
    <FadeIn className="flex flex-col gap-4 mb-14 text-center sm:text-left">
      <p className="text-emerald-400 text-xs font-bold uppercase tracking-[0.3em]">
        Gurugram Branch
      </p>
      <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-white">
        Our Elite. Discreet. Relaxing.{" "}
        <span className="bg-gradient-to-r from-amber-300 via-yellow-500 to-amber-600 bg-clip-text text-transparent">
          Facilities
        </span>
      </h2>
    </FadeIn>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-5xl mx-auto">
      {FACILITIES.map((f, i) => {
        const borderClass = BORDERS[i % BORDERS.length];
        return (
          <FadeIn key={f.title} delay={(i % 2) * 0.1}>
            <div
              data-testid={`facility-card-${i}`}
              className={`group relative overflow-hidden rounded-2xl aspect-square bg-black/40 ${borderClass} transition-all duration-300 hover:scale-[1.02]`}
            >
              <img
                src={f.image}
                alt={f.title}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
          </FadeIn>
        );
      })}
    </div>
  </section>
);
